import { DialogProps } from '@mui/material'
import { action, makeObservable, observable } from 'mobx'
import { ReactNode } from 'react'

const defaultOptions: DialogProps = {
  open: false,
  maxWidth: 'sm',
  slotProps: {
    paper: { sx: { minHeight: '90%' } },
  },
}
export class DialogStore {
  view: ReactNode | undefined = undefined
  options: DialogProps = defaultOptions

  constructor() {
    makeObservable(this, {
      view: observable,
      options: observable,
      openDialog: action,
      close: action,
    })
  }

  openDialog(content?: ReactNode, fullScreen = false, options?: DialogProps) {
    this.view = content
    this.options = { ...defaultOptions, ...options, open: true, fullScreen }
  }

  close = () => {
    this.options.open = false
  }
}
